import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9F5F2EFA-5AED-4914-9ADC-3C2C7EC60386
 * name sort-variant-off
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-variant-off.svg
 * tags
 * - Text / Content / Format 
 */
export const SortVariantOffIcon = createSvgIcon(<><path d="M20.84 22.73L11.11 13H3V11H9.11L6.11 8H3V6H4.11L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M15 11H14.2L15 11.8V11M21 8V6H9.2L11.2 8H21M3 18H9V16H3V18Z" /></>, 'SortVariantOffIcon');
export default SortVariantOffIcon